var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectsCharitiesSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "selection 1",
    clipPath: "url(#clip0_1388_4214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.83268 10.8333C3.63668 10.8333 2.66602 9.86267 2.66602 8.66667V6.5C2.66602 2.91633 5.58235 0 9.16602 0H11.3327C12.5287 0 13.4993 0.970667 13.4993 2.16667C13.4993 3.36267 12.5287 4.33333 11.3327 4.33333H9.16602C7.97218 4.33333 6.99935 5.30617 6.99935 6.5V8.66667C6.99935 9.86267 6.02868 10.8333 4.83268 10.8333Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M43.8327 10.8333C42.6367 10.8333 41.666 9.86267 41.666 8.66667V6.5C41.666 5.30617 40.6932 4.33333 39.4993 4.33333H37.3327C36.1367 4.33333 35.166 3.36267 35.166 2.16667C35.166 0.970667 36.1367 0 37.3327 0H39.4993C43.083 0 45.9993 2.91633 45.9993 6.5V8.66667C45.9993 9.86267 45.0287 10.8333 43.8327 10.8333Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.6673 4.33333H20.0007C18.8047 4.33333 17.834 3.36267 17.834 2.16667C17.834 0.970667 18.8047 0 20.0007 0H28.6673C29.8633 0 30.834 0.970667 30.834 2.16667C30.834 3.36267 29.8633 4.33333 28.6673 4.33333Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.334 43.3333H20.0007C18.8047 43.3333 17.834 42.3627 17.834 41.1667C17.834 39.9707 18.8047 39 20.0007 39H24.334C25.53 39 26.5007 39.9707 26.5007 41.1667C26.5007 42.3627 25.53 43.3333 24.334 43.3333Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.3327 43.3333H9.16602C5.58235 43.3333 2.66602 40.417 2.66602 36.8333V34.6667C2.66602 33.4707 3.63668 32.5 4.83268 32.5C6.02868 32.5 6.99935 33.4707 6.99935 34.6667V36.8333C6.99935 38.0272 7.97218 39 9.16602 39H11.3327C12.5287 39 13.4993 39.9707 13.4993 41.1667C13.4993 42.3627 12.5287 43.3333 11.3327 43.3333Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.83268 28.1666C3.63668 28.1666 2.66602 27.196 2.66602 26V17.3333C2.66602 16.1373 3.63668 15.1666 4.83268 15.1666C6.02868 15.1666 6.99935 16.1373 6.99935 17.3333V26C6.99935 27.196 6.02868 28.1666 4.83268 28.1666Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M43.8327 23.8333C42.6367 23.8333 41.666 22.8626 41.666 21.6666V17.3333C41.666 16.1373 42.6367 15.1666 43.8327 15.1666C45.0287 15.1666 45.9993 16.1373 45.9993 17.3333V21.6666C45.9993 22.8626 45.0287 23.8333 43.8327 23.8333Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M52.0587 40.352L31.6205 19.9138C31.354 19.6473 31.0008 19.5 30.6217 19.5C29.8417 19.5 29.209 20.1327 29.209 20.9127V50.5852C29.209 51.3652 29.8417 51.9978 30.6217 51.9978C31.003 51.9978 31.3627 51.8483 31.6378 51.5667L40.1247 42.7657H51.0642C51.8442 42.7657 52.4768 42.133 52.4768 41.353C52.4768 40.9803 52.3252 40.6163 52.0587 40.352Z",
    fill: "#004080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_4214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectsCharitiesSvg);
export default __webpack_public_path__ + "static/media/SelectsCharitiesSvg.7f3853402f9f0013ab4b546f0de4e97a.svg";
export { ForwardRef as ReactComponent };